import videojs from "@/vendor/videojs/video.es.js";

const Plugin = videojs.getPlugin("plugin");

class HiRecorder extends Plugin {
  constructor(player, options) {
    super(player, options);
    this.on(player, "recordSegments", this.recordSegments);
    this.on(player, "stopRecordingSegments", this.stopRecordingSegments);
  }
  dispose() {
    super.dispose();
  }
  recordSegments(event, recordedSegments) {
    let that = this;
    this.recordedSegments = recordedSegments;
    this.player.controlBar.progressControl.disable();

    let targetDuration = this.player.tech().hls.playlists.media()
      .targetDuration;

    recordedSegments.push(that.getCurrentSegment());

    this.recordingInterval = window.setInterval(() => {
      let currentSegment = that.getCurrentSegment();
      if (recordedSegments.includes(currentSegment) == false) {
        recordedSegments.push(currentSegment);
      }
    }, 1000);
  }
  stopRecordingSegments(event, edgeSegments) {
    window.clearInterval(this.recordingInterval);
    let newEdgeSegments = this.getEdgeSegments();
    newEdgeSegments.forEach(edgeSegment => edgeSegments.push(edgeSegment));
    this.player.controlBar.progressControl.enable();
  }
  getEdgeSegments() {
    let mediaSegments = this.player.tech().hls.playlists.media().segments;
    let firstEdge, lastEdge = null;
    let edgeSegments = [];
    let firstIndex = mediaSegments.findIndex((element) => element == this.recordedSegments[0]);
    let lastIndex = mediaSegments.findIndex((element) => element == this.recordedSegments[this.recordedSegments.length - 1]);

    if (firstIndex !== 0) {
      firstEdge = mediaSegments[firstIndex - 1];
      firstEdge.side = "front";
      firstEdge.index = firstIndex - 1;
      edgeSegments.push(firstEdge);
    }

    if (lastIndex !== mediaSegments.length - 1) {
      lastEdge = mediaSegments[lastIndex + 1];
      lastEdge.side = "back";
      lastEdge.index = lastIndex + 1;
      edgeSegments.push(lastEdge);
    }

    return edgeSegments;
  }
  getCurrentSegment() {
    let targetMedia = this.player.tech().hls.playlists.media();
    let snapshotTime = this.player.currentTime();
    let segment;
    //let segment_time;

    // Itinerate trough available segments and get first within which snapshotTime is
    for (let i = 0, l = targetMedia.segments.length; i < l; i++) {
      // Note: segment.end may be undefined or is not properly set
      if (snapshotTime < targetMedia.segments[i].end) {
        segment = targetMedia.segments[i];
        segment.index = i;
        break;
      }
    }

    // Null segment_time in case it's lower then 0.
    if (segment) {
      //segment_time = Math.max(0, snapshotTime - (segment.end - segment.duration));
      // Because early segments don't have end property
    } else {
      segment = targetMedia.segments[0];
      segment.index = 0;
      //segment_time = 0;
    }

    return segment;
  }
}

videojs.registerPlugin("HiRecorder", HiRecorder);
